export type SupportedLocale = "ru" | "en" | "fr" | "sw";
export const Locale_RU = "ru";
export const Locale_EN = "en";
export const Locale_FR = "fr";
export const Locale_SW = "sw";
